<template>
  <div class="list">
    <div class="header">
      <h3 class="sub-title">
        {{title}}
      </h3>
      <div class="button-box">
        <!-- <v-btn
          color="white"
          class="red--text"
        >
        <v-icon
          left
          dark
        >
          mdi-microsoft-excel
        </v-icon>
          Сформировать отчет
        </v-btn> -->
      </div>
    </div>
    <div class="responsive">
      <v-skeleton-loader
       v-if="!load"
        class="mx-auto"
        type="table-tbody"
      ></v-skeleton-loader>
      <table class="table table-search table-no-link" v-else>
        <thead>
          <tr>
            <th
              v-for="header in headers"
              :key="header.text"
              class="text-center">
              {{header.text}}
              <div class="search">
                <input type="text">
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="table in getReports"
            :key="table.code"
          >
            <td class="text-center">{{table.code}}</td>
            <td class="text-center name">{{table.standartName}}</td>
            <td class="text-center">{{table.clinrec}}</td>
            <td class="text-center">{{table.name}}</td>
            <td class="text-center">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span
                  v-bind="attrs"
                  v-on="on">{{table.depNumber}}</span>
                </template>
                <span>{{table.department}}</span>
              </v-tooltip>
            </td>
            <td class="text-center">{{table.params}}</td>
            <td class="text-center">{{table.change}}</td>
            <td class="text-center">{{table.value}}</td>
            <td class="text-center">{{table.createData | moment("DD-MM-YYYY")}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapActions, mapMutations} from 'vuex'
  export default {
    name: 'ListBlood',
    data () {
      return {
        title: 'Список замечаний  (Кровь)',
        load: false,
        headers: [
          {text: 'Код СМП'},
          {text: 'Наименование стандарта'},
          {text: 'Клиническая рекомендация'},
          {text: 'ФИО согласующего'},
          {text: 'Департамент'},
          {text: 'Параметр'},
          {text: 'Обоснование изменение'},
          {text: 'Предлагаемое значение'},
          {text: 'Дата добавления замечания'}
        ],
      }
    },
    computed : {
      ...mapGetters({
          getReports: 'reports/getReports',
      }),
    },
    methods: {
      ...mapActions({
          reports: 'reports/reports',
      }),
      ...mapMutations({
          setSearch: 'reports/setSearch',
      }),
    },
    mounted() {
      this.reports('consumable').then(() => this.load = true)
    }
  }
</script>
